import { defineSingleValueFilter } from '../engine/descriptor';
import { type FilterId, FilterType } from '../types/filters';

/**
 * Selection shape shared by every numeric-taxonomy filter (skill, activity):
 * a plain taxonomy id plus the version it was saved under. Role differs (its
 * selection is an object union) and keeps its own definition.
 */
export type NumericTaxonomySelection = {
  taxonomyId?: number;
  version?: string;
};

export const defineNumericTaxonomyFilter = <const Id extends FilterId>({
  id,
  name,
}: {
  id: Id;
  name: string;
}) =>
  defineSingleValueFilter<NumericTaxonomySelection>()({
    definition: {
      id,
      name,
      value: { taxonomyId: 0 },
      type: FilterType.VALUE,
      isVisible: false,
      isActive: true,
    },
  });
